import React from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from '../components/Common/Breadcrumb';

const BusinessSetup = () => {
  const services = [
    {
      id: 1,
      title: "Business Registration & Incorporation",
      description: "• Federal Incorporation\n• Provincial Registration\n• Structure Selection (Sole Proprietor, Partnership, Corporation)",
      icon: "fas fa-building"
    },
    {
      id: 2,
      title: "CRA Account Setup",
      description: "• Business Number (BN)\n• GST/HST Account\n• Payroll & Corporate Tax Accounts",
      icon: "fas fa-file-invoice-dollar"
    },
    {
      id: 3,
      title: "Business Plan Preparation",
      description: "• Immigration-focused Plans\n• Investor/Bank Financing Plans\n• Operational Business Planning",
      icon: "fas fa-chart-line"
    },
    {
      id: 4,
      title: "Licensing & Permits",
      description: "• Municipal Licensing\n• Provincial Licensing\n• Federal Licensing",
      icon: "fas fa-certificate"
    },
    {
      id: 5,
      title: "Banking & Financial Setup",
      description: "• Business Bank Account\n• Credit Services\n• Merchant Services Guidance",
      icon: "fas fa-university"
    },
    {
      id: 6,
      title: "Website & Digital Presence",
      description: "• Branding & Logo Design\n• Website Development\n• Social Media Setup\n• Marketing Strategy",
      icon: "fas fa-globe"
    }
  ];

  return (
    <>
      <Breadcrumb title="Business Setup" />


      <div className="container-fluid service overflow-hidden pt-5">
      <div className="container py-5">
        <div className="section-title text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">
          <div className="sub-style">
            <h5 className="sub-title text-primary px-3">Business Setup Services</h5>
          </div>
          <h1 className="display-5 mb-4">Comprehensive solutions for entrepreneurs starting their business journey in Canada</h1>
          <p className="mb-0">From choosing the right business structure to registration, CRA account setup, licensing, and banking—we guide you through every essential step. Our tailored business plans and digital presence support help you launch with confidence, ensuring your venture meets both operational and immigration requirements.</p>
        </div>
      </div>
      </div>

      {/* Services Section */}
      <div id="services" className="container-fluid">
        <div className="container py-5">
          <div className="row g-4">
            {services.map((service) => (
              <div key={service.id} className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay={`${service.id * 0.1}s`}>
                <div className="service-card h-100 bg-white rounded shadow-sm p-4 border-0 hover-lift">
                  <div className="text-center mb-4">
                    <div className="service-icon bg-primary rounded-circle d-inline-flex align-items-center justify-content-center" style={{ width: '80px', height: '80px' }}>
                      <i className={`${service.icon} fa-2x text-white`}></i>
                    </div>
                  </div>
                  <h4 className="text-primary mb-3 text-center">{service.title}</h4>
                  <p className="text-muted text-center mb-0" style={{ whiteSpace: 'pre-line' }}>{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Contact CTA Section */}
      <div className="container-fluid bg-light">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center wow fadeInUp" data-wow-delay="0.1s">
              <h2 className="text-primary mb-4">Ready to start your business journey in Canada?</h2>
              <p className="text-muted fs-5 mb-4">Let us help you get started today.</p>
              <Link to="/contact" className="btn btn-primary btn-lg rounded-pill px-5">Get Started</Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BusinessSetup; 